import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class ClassificationService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getAllClassification(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'reportmaster/getclassification').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getClassification(id: number,isMaintenance: boolean = true): Observable<any> {
   
    return this.httpClient.get(this.baseApiUrl + `reportmaster/getclassificationbyid?id=${id}&isMaintenance=${isMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  createClassification(classification: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'reportmaster/createclassification', classification).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateClassification(classification: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'reportmaster/updateclassification', classification).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `reportmaster/deleteclassification?id=${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'reportmaster/authoriseclassification', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFilteredClassification(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'reportmaster/reportclassficationfilter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

}
